// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__oWbG7","footer":"ModalFilter_footer__14iqw"};